import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Copy, RefreshCw } from "lucide-react";

const CHARS = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789!@#$%&*?";
const gen = (len = 16) => Array.from(crypto.getRandomValues(new Uint32Array(len))).map((n) => CHARS[n % CHARS.length]).join("");
const strength = (p) => {
  let s = 0;
  if (p.length >= 12) s++; if (p.length >= 16) s++;
  if (/[a-z]/.test(p) && /[A-Z]/.test(p)) s++;
  if (/\d/.test(p)) s++; if (/[^\w]/.test(p)) s++;
  return Math.min(s, 4);
};

export default function ModuleVault() {
  const [pwd, setPwd] = useState("");
  const s = strength(pwd);
  const labels = ["", "Débil", "Media", "Buena", "Fuerte"];
  const colors = ["bg-navy/10", "bg-destructive", "bg-amber-500", "bg-violet", "bg-emerald-500"];

  return (
    <div className="mt-4 border-t border-navy/10 pt-4 space-y-3" data-testid="module-vault">
      <div className="overline text-navy/40">Generador de contraseñas seguras</div>
      <div className="flex gap-2">
        <input readOnly value={pwd} placeholder="Genera una contraseña fuerte" className="flex-1 bg-navy/[0.03] border border-navy/10 rounded-lg px-3 py-2 font-mono text-sm text-navy/80" data-testid="vault-password" />
        <button onClick={() => setPwd(gen())} className="btn btn-primary" data-testid="vault-generate"><RefreshCw className="w-4 h-4" /></button>
        <button onClick={() => { if (pwd) { navigator.clipboard.writeText(pwd); toast.success("Copiada"); } }} className="btn btn-ghost" data-testid="vault-copy"><Copy className="w-4 h-4" /></button>
      </div>
      {pwd && (
        <div className="flex items-center gap-2">
          <div className="flex-1 h-1.5 rounded-full bg-navy/10 overflow-hidden"><div className={`h-full rounded-full ${colors[s]} transition-all`} style={{ width: `${(s / 4) * 100}%` }} /></div>
          <span className="text-xs text-navy/50 flex items-center gap-1"><KeyRound className="w-3.5 h-3.5" /> {labels[s]}</span>
        </div>
      )}
    </div>
  );
}
